module.exports = __webpack_public_path__ + "img/5e97663.svg";